import {BmpProductionScheduleItemInPathGroup} from '@domain/production-schedule/bmp-production-schedule-item-in-path-group';
import {DrawingType} from '@domain/production-schedule/drawing-type.enum';
import {ProductionScheduleItemInPathGroup} from '@domain/production-schedule/production-schedule-item-in-path-group';
import {NotImplementedError} from '@vdw/angular-component-library';

export function applyChangesToNewProductionScheduleItemInPathGroup(
  newProductionScheduleItemInPathGroup: ProductionScheduleItemInPathGroup,
  productionScheduleItemInPathGroup: ProductionScheduleItemInPathGroup
): void {
  newProductionScheduleItemInPathGroup.adjustQuantityOfDrawingsInPathGroup(productionScheduleItemInPathGroup.quantity);
  newProductionScheduleItemInPathGroup.commercialDimensionsInMM = productionScheduleItemInPathGroup.commercialDimensionsInMM;
  newProductionScheduleItemInPathGroup.technicalDimensions = productionScheduleItemInPathGroup.technicalDimensions;

  switch (productionScheduleItemInPathGroup.drawing.drawingType) {
    case DrawingType.EP:
      throw new NotImplementedError();
    case DrawingType.BMP:
      const bmpProductionScheduleItemInPathGroup: BmpProductionScheduleItemInPathGroup = newProductionScheduleItemInPathGroup as BmpProductionScheduleItemInPathGroup;
      bmpProductionScheduleItemInPathGroup.changeFinishing((productionScheduleItemInPathGroup as BmpProductionScheduleItemInPathGroup).finishing);
      break;
  }
}
